import { AxiosError, AxiosInstance } from 'axios';
import { ErrorHandler } from '@/services/errorHandler/types';
import { Store, Dispatch } from 'vuex';
import { RootState } from '@/store/types';

export const pending = (reqCounter: number, dispatch: Dispatch): number => {
  const counter = reqCounter + 1;
  if (counter === 1) {
    dispatch('global/showSpinner');
  }
  return counter;
};

export const done = (reqCounter: number, dispatch: Dispatch): number => {
  const counter = reqCounter - 1;
  if (counter === 0) {
    dispatch('global/hideSpinner');
  }
  return counter;
};

export const showErrorPopup = (
  error: AxiosError,
  dispatch: Dispatch,
  errorHandler: ErrorHandler,
): void => {
  const errorMsgKey = errorHandler.handle(error);
  dispatch('global/showErrorPopup', errorMsgKey);
};

export const isAuthError = (error: AxiosError, dispatch: Dispatch): void => {
  if (error.response?.status === 401 || error.response?.status === 403) {
    dispatch('auth/logout');
  }
};

const setAxiosInterceptor = (
  { dispatch }: Store<RootState>,
  Axios: AxiosInstance,
  errorHandler: ErrorHandler,
) => {
  let requestsPending = 0;

  Axios.interceptors.request.use(
    (config) => {
      requestsPending = pending(requestsPending, dispatch);
      const token = window.localStorage.getItem('store')
        ? JSON.parse(window.localStorage.getItem('store')!).auth.token
        : '';

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: AxiosError) => {
      requestsPending = done(requestsPending, dispatch);
      showErrorPopup(error, dispatch, errorHandler);
      return Promise.reject(error);
    },
  );

  Axios.interceptors.response.use(
    (response) => {
      requestsPending = done(requestsPending, dispatch);
      return response;
    },
    (error: AxiosError) => {
      requestsPending = done(requestsPending, dispatch);
      isAuthError(error, dispatch);
      showErrorPopup(error, dispatch, errorHandler);
      return Promise.reject(error);
    },
  );
};

export default setAxiosInterceptor;
